import React from "react";
import { FcGoogle } from "react-icons/fc";
import { IoReloadCircleSharp } from "react-icons/io5";
import { FiEye, FiEyeOff } from "react-icons/fi";
import OTPInput from "react-otp-input";
import { Link } from "react-router-dom";
import { Footer } from "../../../components";

function Register({
  currentStatus,
  handleGlogin,
  handleChange,
  handleVerifyEmail,
  handleVerifyOtp,
  handleManualRes,
  user,
  otp,
  setOtp,
  load,
  otpSent,
  otpError,
  otpErrorMsg,
  onSendOtp,
  onVerifyOtp,
  onGoBack,
  showPassword,
  showConfirmPassword,
  toggleShowPassword,
  toggleShowConfirmPassword,
}) {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-col items-center justify-center bg-gray-50 px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8">
          <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-8">
            {currentStatus === "verifyEmail" && "Create your account"}
            {currentStatus === "verifyOtp" && "Verify OTP"}
            {currentStatus === "addPassword" && "Set Up Password"}
          </h1>

          <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
            {currentStatus === "verifyEmail" ||
            currentStatus === "verifyOtp" ? (
              <>
                <button
                  type="button"
                  onClick={handleGlogin}
                  className="w-full flex justify-center items-center gap-3 border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 font-semibold rounded-lg px-5 py-3">
                  <FcGoogle size={26} />
                  Sign up with Google
                </button>

                <div className="relative flex items-center my-4">
                  <div className="flex-grow border-t border-gray-300"></div>
                  <span className="mx-3 text-gray-400 text-sm font-medium">
                    or
                  </span>
                  <div className="flex-grow border-t border-gray-300"></div>
                </div>

                {!otpSent && (
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-gray-700">
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                      disabled={load}
                      className="w-full border border-gray-300 rounded-md p-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                )}

                {otpSent && (
                  <div className="flex flex-col items-center gap-3">
                    <label className="block mb-2 text-sm font-semibold text-gray-700">
                      Enter OTP sent to {user.email}
                    </label>
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderInput={(props) => (
                        <input {...props} className="otp-input" />
                      )}
                      shouldAutoFocus
                      isInputNum
                      containerStyle="justify-center flex gap-2"
                    />
                    {otpError && (
                      <p className="text-red-600 text-sm">{otpErrorMsg}</p>
                    )}
                  </div>
                )}

                <button
                  type="button"
                  disabled={load}
                  onClick={otpSent ? onVerifyOtp : onSendOtp}
                  className={`w-full py-3 rounded-md font-semibold text-white transition ${
                    load
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-primary hover:bg-darkprimary"
                  }`}>
                  {load ? (
                    <div className="flex gap-2 justify-center items-center">
                      <IoReloadCircleSharp className="w-6 h-6 animate-spin" />
                      {otpSent ? "Verifying..." : "Sending..."}
                    </div>
                  ) : otpSent ? (
                    "Verify OTP"
                  ) : (
                    "Send OTP"
                  )}
                </button>

                {otpSent && (
                  <button
                    type="button"
                    onClick={onGoBack}
                    className="w-full mt-3 py-3 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300 font-semibold">
                    Go Back
                  </button>
                )}
              </>
            ) : null}

            {currentStatus === "addPassword" && (
              <div className="space-y-4">
                <div>
                  <label className="block mb-2  font-semibold text-gray-700">
                    Account Email
                  </label>
                  <p className="w-full p-3 bg-gray-100 rounded-md text-gray-800">
                    {user.email}
                  </p>
                </div>

                <div className="relative">
                  <label className="block mb-2  font-semibold text-gray-700">
                    Create Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={user.password}
                    onChange={handleChange}
                    placeholder="••••••••"
                    required
                    className="w-full border p-3 rounded-md"
                  />
                  <button
                    type="button"
                    onClick={toggleShowPassword}
                    className="absolute right-3 top-11">
                    {showPassword ? (
                      <FiEyeOff size={20} />
                    ) : (
                      <FiEye size={20} />
                    )}
                  </button>
                </div>

                <div className="relative">
                  <label className="block mb-2 font-semibold text-gray-700">
                    Confirm Password
                  </label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="c_pass"
                    value={user.c_pass}
                    onChange={handleChange}
                    placeholder="••••••••"
                    required
                    className="w-full border p-3 rounded-md"
                  />
                  <button
                    type="button"
                    onClick={toggleShowConfirmPassword}
                    className="absolute right-3 top-11">
                    {showConfirmPassword ? (
                      <FiEyeOff size={20} />
                    ) : (
                      <FiEye size={20} />
                    )}
                  </button>
                </div>

                <button
                  type="button"
                  disabled={load}
                  onClick={handleManualRes}
                  className={`w-full py-3 rounded-md font-semibold text-white transition ${
                    load
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-primary hover:bg-darkprimary"
                  }`}>
                  {load ? "Saving..." : "Save Password"}
                </button>
              </div>
            )}

            <div className="text-sm mt-4 text-center">
              <p className="text-gray-600">
                Already have an account?{" "}
                <Link to="/login" className="text-blue-600 hover:underline">
                  Log In
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Register;
